import getters from './getters.js';

export default {
	state: {
		schools: null,
		summary: null,
		schoolHistory: null,
		evaluation: null,
		issue: null,
		synthesis: null,
		trainingTalks: null,
		synthesesDashboard: null
	},
	mutations: {
		SET_ADMIN_SCHOOLS (state, schools) {
			state.schools = schools;
		},
		SET_SUMMARY_SCHOOLS (state, summary) {
			state.summary = summary;
		},
		SET_ADMIN_SCHOOL_HISTORY (state, schoolHistory) {
			state.schoolHistory = schoolHistory;
		},
		SET_ADMIN_EVALUATION (state, evaluation) {
			state.evaluation = evaluation;
		},
		SET_ADMIN_ISSUE (state, issue) {
			state.issue = issue;
		},
		SET_ADMIN_SYNTHESIS (state, synthesis) {
			state.synthesis = synthesis;
		},
		SET_TRAINING_TALKS (state, trainingTalks) {
			state.trainingTalks = trainingTalks;
		},
		SET_ADMIN_SYNTHESES_DASHBOARD (state, synthesesDashboard) {
			state.synthesesDashboard = synthesesDashboard;
		},
		CLEAR_SUMMARY_SCHOOLS (state) {
			state.summary = null;
		},
		CLEAR_ADMIN_SCHOOLS (state) {
			state.schools = null;
		},
		CLEAR_ADMIN_SCHOOL_HISTORY (state) {
			state.schoolHistory = null;
		},
		CLEAR_ADMIN_EVALUATION (state) {
			state.evaluation = null;
		},
		CLEAR_ADMIN_ISSUE (state) {
			state.issue = null;
		},
		CLEAR_ADMIN_SYNTHESIS (state) {
			state.synthesis = null;
		},
		CLEAR_TRAINING_TALKS (state) {
			state.trainingTalks = null;
		},
		CLEAR_ADMIN_SYNTHESES_DASHBOARD (state) {
			state.synthesesDashboard = null;
		}
	},
	actions: {
		async setAdminSchools (context, summary) {
			context.commit('SET_ADMIN_SCHOOLS', summary);
		},

		async setSummarySchools (context, summary) {
			context.commit('SET_SUMMARY_SCHOOLS', summary);
		},

		async setAdminSchoolHistory (context, progress) {
			context.commit('SET_ADMIN_SCHOOL_HISTORY', progress);
		},

		async setAdminSynthesis (context, synthesis) {
			context.commit('SET_ADMIN_SYNTHESIS', synthesis);
		},

		async setAdminIssue (context, issue) {
			context.commit('SET_ADMIN_ISSUE', issue);
		},

		async setAdminEvaluation (context, evaluation) {
			context.commit('SET_ADMIN_EVALUATION', evaluation);
		},

		async setTrainingTalks (context, trainingTalks) {
			context.commit('SET_TRAINING_TALKS', trainingTalks);
		},

		async setAdminSynthesesDashboard (context, synthesesDashboard) {
			context.commit('SET_ADMIN_SYNTHESES_DASHBOARD', synthesesDashboard);
		},

		async clearAdminSchools (context) {
			context.commit('CLEAR_ADMIN_SCHOOLS');
		},

		async clearSummarySchools (context) {
			context.commit('CLEAR_SUMMARY_SCHOOLS');
		},

		async clearAdminSchoolHistory (context) {
			context.commit('CLEAR_ADMIN_SCHOOL_HISTORY');
		},

		async clearAdminEvaluation (context) {
			context.commit('CLEAR_ADMIN_EVALUATION');
		},

		async clearAdminIssue (context) {
			context.commit('CLEAR_ADMIN_ISSUE');
		},

		async clearAdminSynthesis (context) {
			context.commit('CLEAR_ADMIN_SYNTHESIS');
		},

		async clearTrainingTalks (context) {
			context.commit('CLEAR_TRAINING_TALKS');
		},

		async clearAdminSynthesesDashboard (context) {
			context.commit('CLEAR_ADMIN_SYNTHESES_DASHBOARD');
		}
	},
	getters
};



// WEBPACK FOOTER //
// ./src/store/admin/index.js